<template>
  <div class="event-sale-filter d-flex flex-column gap-3">
    <checkboxes-dropdown
      v-model="value.product_id"
      masculine
      label="Evento"
      id="product-select"
      placeholder="Selecione o evento"
      :options="productOptions"
    />

    <checkboxes-dropdown
      v-model="value.status"
      masculine
      label="Status"
      id="status-select"
      placeholder="Selecione o status"
      :options="statuses"
    />

    <checkboxes-dropdown
      v-model="value.payment_method"
      masculine
      id="payment_method-select"
      label="Método de pagamento"
      placeholder="Selecione o método"
      :options="paymentMethods"
    />

    <bp-input
      v-model="value.current_install"
      number
      id="current_install"
      label="Cobrança"
      placeholder="Digite a cobrança"
      :min="0"
    />

    <bp-input
      v-model="value.installments"
      number
      id="installments"
      label="Parcelamento"
      placeholder="Digite a quantidade de parcelas"
      :min="0"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      paymentMethods: [
        { id: "card", name: "1 cartão" },
        { id: "two_card", name: "2 cartões" },
        { id: "billet", name: "Boleto" },
        { id: "pix", name: "Pix" },
        { id: "smart_card", name: "Parcelamento Inteligente (1 Cartão)" }
      ],
      statuses: [
        { id: "paid", name: "Aprovado" },
        { id: "created", name: "Criado" },
        { id: "pending", name: "Pendente" },
        { id: "completed", name: "Completo" },
        { id: "chargeback", name: "Chargeback" },
        { id: "failed", name: "Falha na Cobrança" },
        { id: "reversal", name: "Estorno Automático" },
        {
          id: "reversal_manual",
          name: "Estorno Manual"
        }
      ]
    };
  },
  computed: {
    ...mapState("integration", ["coproducerProducts"]),
    productOptions() {
      return this.coproducerProducts.map(
        ({ product_id: id, product_name: name }) => ({
          id,
          name
        })
      );
    }
  }
};
</script>
